export const appExtraFunctions = (type, values) => dispatch => {
  switch (type) {
    case 'btnLoaderOne':
      return dispatch({
        type: 'BTN_LOADER_ONE',
        payload: values,
      });
    case 'storeRegistrationForm':
      return dispatch({
        type: 'STORE_REGISTRATION_FORM',
        payload: values,
      });
    case 'adminView':
      return dispatch({
        type: 'SAVE_ADMIN_VIEW',
        payload: values,
      });
    case 'saveBillingValues':
      return dispatch({
        type: 'SAVE_BILLING_VALUES',
        payload: values,
      });
    case 'saveActiveStep':
      return dispatch({
        type: 'SAVE_ACTIVE_STEP',
        payload: values,
      });

    default:
      break;
  }
};

export const resetActionValues = (type, value) => dispatch => {
  dispatch({ type, payload: value });
};
